import createTypes from 'redux-create-action-types';

export default createTypes(
  'UPDATE_SM_FACTORY_PROFILE',
  'CREATE_SM_FACTORY_INTERNAL_NOTES', 
  'GET_SM_FACTORY_INTERNAL_NOTES', 
  'UPDATE_SM_FACTORY_INTERNAL_NOTES',
  'DELETE_SM_FACTORY_INTERNAL_NOTES'
);
